var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.99996 0.0429688C4.05996 0.0429688 0.041626 4.06214 0.041626 9.0013C0.041626 13.9405 4.05996 17.9596 8.99996 17.9596C13.94 17.9596 17.9583 13.9405 17.9583 9.0013C17.9583 4.06214 13.94 0.0429688 8.99996 0.0429688ZM8.99996 16.7096C4.74913 16.7096 1.29163 13.2521 1.29163 9.0013C1.29163 4.75047 4.74913 1.29297 8.99996 1.29297C13.2508 1.29297 16.7083 4.75047 16.7083 9.0013C16.7083 13.2521 13.2508 16.7096 8.99996 16.7096ZM12.5416 9.0013C12.5416 9.3463 12.2616 9.6263 11.9166 9.6263H9.62496V11.918C9.62496 12.263 9.34496 12.543 8.99996 12.543C8.65496 12.543 8.37496 12.263 8.37496 11.918V9.6263H6.08329C5.73829 9.6263 5.45829 9.3463 5.45829 9.0013C5.45829 8.6563 5.73829 8.3763 6.08329 8.3763H8.37496V6.08464C8.37496 5.73964 8.65496 5.45964 8.99996 5.45964C9.34496 5.45964 9.62496 5.73964 9.62496 6.08464V8.3763H11.9166C12.2616 8.3763 12.5416 8.6563 12.5416 9.0013Z",
    fill: "#FCFCFD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.03070082f6f1bdeec4d8b0c28c465435.svg";
export { ForwardRef as ReactComponent };